import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './choose.css'

const index = () => {
    return (
        <>
            <section className='px-5'>
                <Container className='p-5'>
                    <Row className='p-5 '>
                        <Row className='row choose-bg my-auto'>
                            <Col>
                                <div className=''>
                                    <img src="img/choose.jpg" className='choose-img' />
                                </div>
                            </Col>
                            <Col>
                                <div className='my-auto '>
                                    <h4 class="roboto-regular fw-bold  mt-4 ">CHOOSE YOUR DEVICE PLATFORM</h4>
                                    <h1 class="intro-h1 mt-3 mb-4 ">Checkout Our App</h1>
                                    <h6 class="">Et optio praesent et! Eligendi ab, irure impedit rhoncus, doloremque! Pretium nobis nobis modi ullamco.</h6>
                                    <Row className='mt-4'>
                                        <Col>
                                            <img src="img/google-play.png" className='app-store' />
                                        </Col>
                                        <Col>
                                            <img src="img/apple-store.png" className='app-store' />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default index
